import { Language } from '../enums';

export type Languages = 'en' | 'fr';

export const supportedLanguages: Languages[] = ['en', 'fr'];
export const defaultLanguage: Languages = 'en';
export const defaultLanguageUpper = Language.English;
